import { useEffect, useRef, useState } from 'react';

import { Button, Form, Input, Modal, Tooltip, notification } from 'antd';
import { useUpdateArticleRelationNoteMutation } from 'services';

/** Modal açılış animasyonu boyunca odak denemesi yapılacak azami frame sayısı (~0.5sn) */
const MAX_FOCUS_ATTEMPTS = 30;

function NoteModal({ note, id }) {
  const [open, setOpen] = useState(false);
  const [form] = Form.useForm();
  const [updateArticleRelationNote, { isLoading }] = useUpdateArticleRelationNoteMutation();

  const formId = `note-modal-${id}`;

  const noteFieldRef = useRef(null);

  /**
   * Modal açıldığında açıklama alanına odaklanır ve imleci metnin sonuna taşır.
   *
   * rc-dialog, modal sarmalayıcısını `display: none` ile tutuyor ve bunu ancak
   * açılıştan sonraki render'da kaldırıyor (Dialog `animatedVisible` state'i).
   * Görünmeyen bir elemana `focus()` sessizce başarısız olduğu için tek seferlik
   * bir çağrı — özellikle Dialog kapalıyken zaten mount edilmişse — kaçabiliyor.
   * Bu yüzden odak gerçekten yerleşene kadar her frame'de yeniden deneniyor.
   */
  useEffect(() => {
    if (!open) return undefined;

    let frame;
    let attemptsLeft = MAX_FOCUS_ATTEMPTS;

    const focusWhenVisible = () => {
      const noteField = noteFieldRef.current;
      noteField?.focus({ cursor: 'end' });

      const focused = noteField?.resizableTextArea?.textArea === document.activeElement;
      attemptsLeft -= 1;
      if (focused || attemptsLeft <= 0) return;

      frame = requestAnimationFrame(focusWhenVisible);
    };

    frame = requestAnimationFrame(focusWhenVisible);
    return () => cancelAnimationFrame(frame);
  }, [open]);

  useEffect(() => {
    form.setFieldsValue({ note: note || '' });
  }, [note, form]);

  async function handleSubmit(value) {
    const { error } = await updateArticleRelationNote({ id, body: value });
    if (error) {
      return notification.error({
        message: 'Not Güncellenirken Bir Hata Oluştu',
        description: error.data.message,
      });
    }
    notification.success({
      message: 'Not Başarıyla Güncellendi',
    });
    setOpen(false);
  }

  return (
    <>
      {note ? (
        <Tooltip
          title={note}
          overlayStyle={{ maxWidth: 400 }}
        >
          <span
            onClick={() => setOpen(true)}
            style={{
              color: '#1890ff',
              cursor: 'pointer',
              maxWidth: 400,
              display: 'inline-block',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              verticalAlign: 'middle',
            }}
          >
            {note}
          </span>
        </Tooltip>
      ) : (
        <Button
          size="small"
          onClick={() => setOpen(true)}
        >
          Ekle
        </Button>
      )}
      <Modal
        open={open}
        onCancel={() => setOpen(false)}
        okText="Kaydet"
        confirmLoading={isLoading}
        okButtonProps={{
          form: formId,
          htmlType: 'submit',
        }}
        cancelText="Kapat"
        destroyOnClose
      >
        <Form
          layout="vertical"
          form={form}
          onFinish={handleSubmit}
          id={formId}
        >
          <Form.Item
            name="note"
            label="Açıklama"
            rules={[
              {
                required: true,
                message: 'Lütfen bir açıklama girin',
              },
            ]}
          >
            <Input.TextArea
              rows={5}
              ref={noteFieldRef}
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}

export default NoteModal;
